import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi, { ISaveIncomeSourcesRequest } from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createSaveIncomeSourcesThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.SaveIncomeSources,
    async (payload: { applicationId: string; incomeSources: ISaveIncomeSourcesRequest }) => {
      const response = await api.saveIncomeSources(payload.applicationId, payload.incomeSources);
      return response;
    },
  );
